export class TechnadoptImage{
    AttachementID: string =''
    Name: string =''
    Location: string =''
    URL: string =''
    FileSize: number = 0
    FileExtension: string =''
    Resolution: string =''
    PreviewName: string =''
    Deleted: boolean = false
    constructor(data?: any) {
        if(!data) return
        this.AttachementID = data['AttachementID']
        this.Name = data['Name']
        this.Location = data['Location']
        this.URL = data['URL']
        this.FileSize = data['FileSize']
        this.FileExtension = data['FileExtension']
        this.Resolution = data['Resolution']
        this.PreviewName = data['PreviewName']
        this.Deleted = data['Deleted']
    }
}